import { ContentButton } from './button';
import { ContentInfo } from './info';

/**
 * Model definition for Sea Exit Box
 */
export interface ContentSeaExitBox {
  __component: 'content.sea-exit-box';
  id: string;
  button: ContentButton;
  automaticForwarding: boolean;
  assignmentHeadline?: string;
  assignmentSubline?: string;
  footnote?: ContentInfo;
  suggests?: number;
  guesses?: number;
}

export function isContentSeaExitBox(obj: { __component?: string }): obj is ContentSeaExitBox {
  return obj.__component === 'content.sea-exit-box';
}
